import { Card, Image } from "react-bootstrap";
import {
  DynamicCardProps,
  DynamicCardCTAStyle,
  DynamicCardType,
} from "src/types";
import { useDynamicCard } from "./dynamic-card.hook";
import { Button, Modal } from "src/ui/widgets";
import { RightArrowIcon } from "src/assets";

export const DynamicCard = ({
  type,
  title,
  description,
  image,
  tagLabel,
  ctaLabel,
  ctaStyle,
  ctaIcon = RightArrowIcon,
  TMModalContent,
  enableTMModal = false,
  action,
}: DynamicCardProps) => {
  const {
    t,
    showTMModal,
    setShowTMModal,
    onConfirmTMModal,
    onPressCardActionButton,
  } = useDynamicCard({
    enableTMModal,
    action,
  });

  const Title = (
    <div
      className={`dynamic-card-title${
        type === DynamicCardType.tile ? "--tile-mode" : "--full-mode"
      }`}
    >
      {title}
    </div>
  );

  const Description = (
    <div
      className={`dynamic-card-description${
        type === DynamicCardType.tile ? "--tile-mode" : "--full-mode"
      }`}
    >
      {description}
    </div>
  );

  const CtaButton = (
    <div>
      {type === DynamicCardType.full ? (
        <Button
          text={ctaLabel}
          iconRight={ctaIcon}
          classesIconRight={`ms-3 ${
            ctaStyle === DynamicCardCTAStyle.fill
              ? "filter-7c2d35"
              : "filter-ffffff"
          }`}
          iconSize={12}
          classesText={`font-12 fw-bold text-uppercase ${
            ctaStyle === DynamicCardCTAStyle.fill ? "c-7c2d35" : "c-ffffff"
          }`}
          classes={`d-flex p-2 ${
            ctaStyle === DynamicCardCTAStyle.fill ? "bg-ffffff" : ""
          }`}
          onPress={onPressCardActionButton}
        />
      ) : (
        <Button
          text={ctaLabel}
          iconRight={ctaIcon}
          classesIconRight={`ms-3 ${
            ctaStyle === DynamicCardCTAStyle.fill
              ? "filter-ffffff"
              : "filter-7c2d35"
          }`}
          iconSize={12}
          classes={`d-flex p-2 ${
            ctaStyle === DynamicCardCTAStyle.fill ? "bg-7c2d35" : "bg-none"
          }`}
          classesText={`font-12 fw-bold text-uppercase ${
            ctaStyle === DynamicCardCTAStyle.fill ? "c-ffffff" : "c-7c2d35"
          }`}
          onPress={onPressCardActionButton}
        />
      )}
    </div>
  );

  const Header = (
    <div
      className={`dynamic-card-header-wrapper ${
        type === DynamicCardType.full ? "order-2 order-md-1" : ""
      }`}
    >
      {tagLabel && <div className="dynamic-card-tag">{t(tagLabel)}</div>}
      {type === DynamicCardType.tile && Title}
      <div className="dynamic-card-overlay" />
      <Image className="dynamic-card-image" src={image} alt={title} />
    </div>
  );

  const Body = (
    <div
      className={`dynamic-card-body-wrapper ${
        type === DynamicCardType.full
          ? "bg-7e303b order-1 order-md-2"
          : "bg-ffffff"
      }`}
    >
      <div className="d-flex flex-column justify-content-between h-100">
        <div>
          {type === DynamicCardType.full && Title}

          {Description}
        </div>
        {CtaButton}
      </div>
    </div>
  );

  const TMModal = (
    <Modal
      visible={true}
      classes="d-md-flex justify-content-left pb-5 pe-5 ps-5 pt-0"
      onClose={() => setShowTMModal(false)}
    >
      <div style={{ maxWidth: "700px" }}>
        <div className="d-md-flex justify-content-left">
          <h2>Target Market</h2>
        </div>
        <div
          className="m-3 ms-0 font-16 c-939393"
          dangerouslySetInnerHTML={{
            __html: (TMModalContent ?? "").replace(/\\n/g, "<br/>"),
          }}
        />
        <Button
          text={t("commons.confirm")}
          onPress={onConfirmTMModal}
          classes="bg-7c2d35 p-4 justify-content-left mt-4"
          iconRight={RightArrowIcon}
          classesIconRight="filter-ffffff"
          classesText="text-uppercase font-16 c-ffffff me-3"
        />
      </div>
    </Modal>
  );

  return (
    <>
      <Card className="rounded-0">
        <div
          className={`dynamic-card${
            type === DynamicCardType.full
              ? "--full-mode flex-column flex-md-row"
              : "--tile-mode flex-column"
          }`}
        >
          {Header}

          {Body}
        </div>
      </Card>
      {showTMModal && TMModalContent && TMModal}
    </>
  );
};
